import Menu from './components/Menu';
import CaregiversMenu from './components/CaregiversMenu';

let currentMenus = [];

document.addEventListener('bless', (e) => {
	if (currentMenus) {
		currentMenus.forEach((menu) => {
			menu.destroy();
		});
		currentMenus = [];
	}

	const html = e.detail.next.html;
	const regex = /<header\b[^>]*>([\s\S]*?)<\/header>/gi;
	const headers = html.match(regex);

	if (!headers) {
		return;
	}

	headers.forEach((header) => {
		const parser = new DOMParser();
		const doc = parser.parseFromString(header, 'text/html');
		const headerEl = doc.querySelector('header');
		const id = headerEl.getAttribute('id');
		const toReplace = document.querySelector(`header#${id}`);
		toReplace.replaceWith(headerEl);

		if (id === 'caregivers_menu') {
			currentMenus.push(new CaregiversMenu(headerEl));
		} else {
			currentMenus.push(new Menu(headerEl));
		}
	});
});
